import Badge from "../../components/badges/Badges";
import { InfoBoard } from "../../components/infoBoard/InfoBoard";
import { Company } from "../../model/Companies";
import { convertDateTimeToString } from "../../utility/ConvertUtily";
import { UserCountList } from "../../model/Users";

export type MunicipalitiesProps = {
  company: Company;
  userCountList: UserCountList;
}

export const MunicipalitiesRef = ({
  company, userCountList
}: MunicipalitiesProps) => {

  const file: { [key: string]: any } = {
    '担当者名': `${company?.managerName} (${company?.managerNameKana})`,
    '担当者E-mail': company?.managerEmail,
    '': '',
    '契約数': `${company?.usersCount}`,
    'ID未登録数': company?.usersCount - userCountList.idRegistered,
    'ID登録数': userCountList.idRegistered,
    'アプリ利用可能': `${userCountList.usable}`,
    'アプリ利用不可数': userCountList.unusable,
    'アプリ利用停止数': userCountList.suspended,
    '作成日': convertDateTimeToString(company?.createAt),
    '更新日': convertDateTimeToString(company?.updateAt),
  };

  return (
    <>
      <div className="mx-auto flex flex-col space-y-2">
        <h3>団体番号: {company.displayId}</h3>
        <div className={"flex space-x-4 items-end"}>
          <h2 className="truncate text-2xl font-bold text-gray-900">
            <ruby>{company.name}<rt>{company.nameKana}</rt></ruby>
          </h2>
          <div>
            {company.deleteFlg
              ? (<Badge color="red">無効</Badge>)
              : (<Badge color="green">有効</Badge>)
            }
            </div>
        </div>
      </div>
      <InfoBoard col={"col3"} filed={file} children={undefined} />
    </>
  )
}